<div class="split-view-container">
  <div class="split-view-primary-column" [ngStyle]="{'width': leftColumnWidth}">
    @if (filter) {
      <div class="filter-container">
        <ng-content select="[wmSplitView='filter']"></ng-content>
      </div>
    }
    <div class="entry-list">
      @if (!dataEmpty && !filterEmpty) {
        <ng-content select="[wmSplitView='entries']"></ng-content>
      }
      @if (dataEmpty) {
        <div class="empty-state">
          {{emptyState}}
        </div>
      }
      @if (!dataEmpty && filterEmpty) {
        <div class="empty-state">
          No entries matching filter
        </div>
      }
    </div>
  </div>
  <div class="split-view-secondary-column">
    <div class="split-view-secondary-scroll-container">
      @if (!dataEmpty && !filterEmpty && !bulkModeActive) {
        <ng-content select="[wmSplitView='details']"></ng-content>
      }
      @if (!dataEmpty && !filterEmpty && bulkModeActive) {
        <ng-content select="[wmSplitView='bulkdetails']"></ng-content>
      }
    </div>
  </div>
</div>
